import lodashIsEqual from 'lodash/isEqual';
/**
 * Checks whether a correlation contains a link by id search.
 *
 * @param {Correlation} correlation
 * @param {Link} link
 */
export function containsLink(correlation, link) {
    return correlation.link.some((_link) => _link.experimentType === link.experimentType &&
        _link.experimentID === link.experimentID &&
        lodashIsEqual(_link.atomType, link.atomType) &&
        _link.signal.id === link.signal.id &&
        _link.axis === link.axis);
}
//# sourceMappingURL=containsLink.js.map